import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-cielo text-navy" data-id="element-44" data-mp="1ntzxx8rhxr1b">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-5" data-id="element-45" data-mp="2bkcbaz5igfza">
        <h2 id="faq" className="text-center font-display text-[1.6rem] font-extrabold uppercase leading-none tracking-tight text-navy sm:text-4xl" data-id="element-46" data-mp="2bkvuskat7cff">
          Preguntas frecuentes
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-47" data-mp="21sgavhfycdrw">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border-2 bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-coral' : 'border-navy/15'}`} data-id="element-48" data-mp="2uiycsf4xw93q" data-mpi={i}>
                <h3 data-id="element-49" data-mp="1vnomkhlfp3js">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 rounded-xl px-3 py-2 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-50" data-mp="1ro63zsh354k4">
                    <span className="font-sub text-sm font-semibold leading-snug" data-id="element-51" data-mp="2ae5l9t6opfcz">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-coral transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-52" data-mp="2jfc448wt329e" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-53" data-mp="2p43u2jijoq22">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-54" data-mp="2u2f0ek9msifj">
                      <p className="px-3 pb-2 text-sm leading-snug text-navy/80" data-id="element-55" data-mp="3d1j6bk5vlw2z">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}